module.exports = __webpack_public_path__ + "media/Splash.9fb896ab.mp3";